export function formatPrice (value) {
  if (typeof value !== 'number') {
    value = parseFloat(value)
  }
  return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function formatPriceWithoutDecimals (value) {
  if (typeof value !== 'number') {
    value = parseFloat(value)
  }
  return value.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
}

export function decodeHtml (html) {
  const txt = document.createElement('textarea')
  txt.innerHTML = html
  return txt.value
}
